import { Button } from '~/components/component-library/Button'
import { SidebarRowDropdown } from '~/components/component-library/internal/Sidebar/components/SidebarRowDropdown'
import { ComponentEntry } from '~/components/component-library/internal/Sidebar/types'

export const SidebarRowButton = (
  props: ComponentEntry & { isActive?: boolean },
) => (
  <Button
    href={{ path: '/component-library/' + props.id + '/' }}
    variant="nav"
    size="small"
    fullWidth
    alignLeft
    isSelected={props.isActive}
    aria-current={props.isActive ? 'page' : undefined}
    suffix={<SidebarRowDropdown {...props} />}
  >
    <span className="flex-1 truncate">{props.name}</span>
  </Button>
)
